<template>
  <div>
    <el-form
      class="login-form form-custom"
      :class="{ 'mgb-more': fromGuest }"
      ref="form"
      label-position="top"
      label-width="80px"
      @submit.native.prevent
      :hide-required-asterisk="true"
      :rules="rules"
      :model="form"
    >
      <!-- 表单 -->
      <el-row
        :class="{ fr: $i18n.locale === 'cn' }"
        :gutter="12"
        v-if="!isMergeLoginAndRegister"
      >
        <el-col :span="12">
          <!-- 名 -->
          <el-form-item
            class="form-item-primary"
            prop="firstName"
            :class="{ 'higher-height': $i18n.locale === 'en' }"
          >
            <BaseInput
              :autofocus="$i18n.locale === 'en' && !isMobile"
              :tabIndexNum="$i18n.locale === 'en' ? '1' : '2'"
              v-model="form.firstName"
              @blur="nameFilter('firstName')"
              :validate-event="Boolean(form.firstName)"
              :placeholer="$t('login.register.firstName')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- 姓 -->
          <el-form-item
            class="form-item-primary"
            prop="lastName"
            :class="{ 'higher-height': $i18n.locale === 'en' }"
          >
            <BaseInput
              :autofocus="$i18n.locale === 'cn' && !isMobile"
              :tabIndexNum="$i18n.locale === 'en' ? '2' : '1'"
              v-model="form.lastName"
              @blur="nameFilter('lastName')"
              :validate-event="Boolean(form.lastName)"
              :placeholer="$t('login.register.lastName')"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 手机号码 -->
      <el-form-item class="form-item-primary" prop="phone">
        <BaseInput
          v-if="hasBanner || isMergeLoginAndRegister"
          v-model="form.phone"
          :disabled="fromPlatform"
          :tabIndexNum="'3'"
          :validate-event="Boolean(form.phone)"
          :placeholer="$t('login.register.enterYourPhone')"
          :maxLength="11"
        >
          <template #prepend>
            <el-select
              :disabled="true"
              v-model="form.pretel"
              style="width: 100px"
              v-if="isShowRegion"
            >
              <el-option
                v-for="item in preTelList"
                :value="item"
                :label="'+' + item"
                :key="'+' + item.toString()"
                >+ {{ item }}</el-option
              >
            </el-select>
            <!-- <div v-else>+{{ form.pretel }}</div> -->
          </template>
        </BaseInput>
        <div v-else class="input-custom-disabled">
          +{{ form.pretel }}&nbsp;&nbsp;{{ form.phone | phoneFormat }}
        </div>
      </el-form-item>

      <!-- 验证码 -->
      <el-form-item class="form-item-primary" prop="verification_code">
        <BaseInput
          v-model.trim="form.verification_code"
          :maxlength="smsLength"
          :validate-event="Boolean(form.verification_code)"
          :placeholer="$t('login.register.labelCode')"
          :tabIndexNum="'4'"
          @focus="changeCode"
        >
          <template #btn>
            <VerificationCode
              ref="verification"
              @click="sendCode"
              :account="form.phone"
              :from="'register'"
            />
          </template>
          <template #prefix>
            {{ $t('login.register.verificationCode') }}
          </template>
        </BaseInput>
      </el-form-item>

      <el-form-item
        v-if="!isMergeLoginAndRegister"
        class="form-item-primary"
        prop="password"
        :class="{ 'higher-height': $i18n.locale === 'en' }"
      >
        <!-- 密码 -->
        <BaseInput
          v-model.trim="form.password"
          type="password"
          @keyup.native="pwdFilter"
          @keyup.enter.native="submit"
          :validate-event="Boolean(form.password)"
          :placeholer="$t('login.register.setPass')"
          :tabIndexNum="'5'"
        />
      </el-form-item>
    </el-form>
    <!-- 南京银行温馨提示 -->
    <div
      class="custom-tips-njcb"
      v-if="isMergeLoginAndRegister && customContent.OwnMoreTips"
    >
      {{ customContent.OwnMoreTips }}
    </div>
    <div
      class="custom-tips-container"
      v-if="isMergeLoginAndRegister && customContent.OwnMoreTips"
      @click="showTips"
    >
      <!-- <el-tooltip popper-class="custom-tips-pop"	:content="customContent.OwnTipsContent" effect="dark" placement="top-start" :offset="4">
        <i class="el-icon-warning tips-icons"></i>
      </el-tooltip> -->
      <img :src="tipsIcon" alt="info" class="njcb-tips-icon" />
      <span class="custom-tips-title">{{ customContent.OwnTipsTitle }}</span
      ><span>{{ customContent.OwnTipsSubTitle }}</span>
    </div>
    <!-- 协议及订阅 -->
    <template v-if="hasAgreement && !hasOwnTermsAndPrivacy">
      <Agreement v-model="form.agreement" />
      <AgreementGSMA v-if="isGSMA" v-model="form.agreementGSMA" />
    </template>

    <el-button
      class="button-custom"
      tabindex="6"
      @click="submit"
      v-track="{
        type: 'click',
        name: `${$route.params.type || 'phone'}.${
          $route.params.step || 'account'
        }.${fromEvent ? 'enterEvent' : 'registerUser'}`,
      }"
      >{{ detailSubmitText }}</el-button
    >

    <!-- 第三方登录 -->
    <template v-if="hasOtherLogin">
      <!-- <BaseLine :text="$t('login.register.or')" /> -->
      <OtherLogin />
    </template>
    <div
      class="user-custom-tips"
      v-if="isMergeLoginAndRegister && customContent.Owndesc"
    >
      <p>{{ customContent.Owndesc }}</p>
    </div>
    <el-dialog
      v-if="dialogVisible"
      title="声明"
      :visible.sync="dialogVisible"
      width="92%"
      :center="true"
      top="26vh"
      custom-class="custom-tips-dialog"
      :show-close="false"
    >
      <div>
        <span>{{ customContent.OwnTipsContent }}</span>
        <p class="dialog-desc-pro">
          *本次南京银行为您提供的元宇宙数字平台“你好世界”由北京有大科技有限公司提供技术协助，继续登录则表明您已阅读并了解
          <a class="proto" :href="handleFinalPath('cterms')">《使用条例》</a>及
          <a class="proto" :href="handleFinalPath('cprivacy')">《隐私政策》</a
          >。
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import VerificationCode from '@/components/login/VerificationCode.vue'
import BaseMixin from '@/mixins/BaseMixin'
import RegisterStepDetailMixin from '../mixins/RegisterStepDetailMixin'
import { checkPhone, checkPassword } from '@/utils/validate-rules'
import { getBusinessType } from '@/constant'
import store from '@/store'
import tipsIcon from '@/assets/images/login/tips.svg'
export default {
  name: '',
  props: {},
  mixins: [BaseMixin, RegisterStepDetailMixin],
  data() {
    return {
      form: {
        phone: '',
      },
      isWrong: false,
      registeredPhone: '',
      tipsIcon: tipsIcon,
      dialogVisible: false,
    }
  },

  components: { VerificationCode },

  computed: {
    smsLength() {
      return store.state.smsLength
    },
    passAccount() {
      return checkPhone(this.currentAccount)
    },
    isMergeLoginAndRegister() {
      return getBusinessType().isMergeLoginAndRegister
    },
    isShowRegion() {
      return getBusinessType().isShowRegion
    },
    hasOwnTermsAndPrivacy() {
      return getBusinessType().hasOwnTermsAndPrivacy
    },
    customContent() {
      return getBusinessType()
    },
    rules() {
      return {
        phone: [
          {
            required: true,
            message: this.$t('login.register.labelRegisteredPhone'),
            trigger: 'blur',
          },
          {
            validator: async (rule, value, callback) => {
              // 已知已注册号码不再提交请求进行多次校验
              this.hasChangePhone()
              if (this.registeredPhone)
                return callback(new Error(this.$t('login.register.exists')))

              if (checkPhone(value)) {
                // 检测是否注册
                if (!getBusinessType().isMergeLoginAndRegister) {
                  await this.handleCheckUserValidator(value, callback)
                } else {
                  callback()
                }
              } else {
                return callback(
                  new Error(this.$t('login.resetPassword.validPhone'))
                )
              }
              return callback(
                new Error(this.$t('login.resetPassword.validPhone'))
              )
            },
            trigger: 'blur',
          },
        ],
        lastName: [
          {
            required: true,
            message: this.$t('login.email.register.ruleLastName'),
          },
        ],
        firstName: [
          {
            required: true,
            message: this.$t('login.email.register.ruleFirstName'),
          },
        ],
        password: [
          {
            required: true,
            message: this.$t('login.email.register.setPassPop'),
          },
          {
            validator: (rule, value, callback) => {
              if (!checkPassword(value)) {
                callback(
                  new Error(this.$t('login.email.register.showPasswordRules'))
                )
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        verification_code: [
          {
            required: true,
            message: this.$t('login.register.labelCode'),
          },
          {
            validator: (rule, value, callback) => {
              if (this.isWrong) {
                callback(
                  new Error(this.$t('login.loginPage.wrongSecurityCode'))
                )
              } else {
                callback()
              }
            },
          },
        ],
      }
    },
    isGSMA() {
      return this.$route.query.event_id == process.env.VUE_APP_GSMA_EVENT_ID
    },
  },
  methods: {
    // 修改电话号码
    hasChangePhone() {
      if (this.form.phone !== this.registeredPhone) this.registeredPhone = ''
    },
    changeCode() {
      this.isWrong = false
    },
    sendCode() {
      if (this.registeredPhone) {
        return
      }
      this.$refs['form'].validateField('phone', (vaild) => {
        if (!vaild) {
          this.$refs['verification'].send()
        }
      })
    },

    creatParams() {
      const { phone, password, firstName, lastName, verification_code } =
        this.form

      return {
        phone,
        password,
        firstName,
        lastName,
        verification_code,
      }
    },
    showTips() {
      this.dialogVisible = true
    },
    handleFinalPath(path) {
      return `${process.env.VUE_APP_SITE}/cn/${path}`
    },
    async handleCheckUserValidator(value, callback) {
      try {
        let data = await store.dispatch('CheckUser', {
          user_name: value,
        })
        if (data.data === true) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.registered = false
          return callback()
        } else {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.registered = true
          return callback(new Error(this.$t('login.register.exists')))
        }
      } catch (error) {
        return callback()
      }
    },

    async fetchRegisterData(params) {
      return await store.dispatch('RegisterByPhone', params)
    },
  },
}
</script>
<style lang="scss" scoped>
.button-custom {
  margin-top: 8px;
}
.form-custom {
  margin-top: 40px;
}
.user-custom-tips {
  font-size: 12px;
  margin-top: 12px;
  color: #5c5c5c;
}
.custom-tips-njcb {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #5c5c5c;
  margin-bottom: 16px;
}
.custom-tips-container {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #5c5c5c;
  margin-bottom: 16px;
  .njcb-tips-icon {
    width: 20px;
    height: 20px;
  }

  .custom-tips-title {
    margin-left: 10px;
  }
  .custom-sub-title {
    color: #ed2e79;
  }
}
.tips-icons {
  font-size: 22px;
  color: #f2555e;
}
.dialog-desc-pro {
  margin-top: 8px;
}
</style>

<style lang="scss">
.custom-tips-dialog {
  border-radius: 16px;
  .el-dialog__title {
    font-size: 16px;
    font-weight: 600;
    color: #14142a;
  }
  .el-button.el-button--primary {
    height: 40px;
    width: 124px;
    background: linear-gradient(
      95.08deg,
      #fd169c 2.49%,
      #fe497a 47.86%,
      #fe7b59 97.19%
    );
    border-radius: 8px;
    border-color: unset;
  }
  .el-dialog__body {
    font-size: 12px;
    line-height: 18px;
    font-weight: 400;
    padding: 0 38px 14px !important;
  }
  .el-dialog__header {
    padding-top: 44px;
  }
  .proto {
    color: #ed2e79;
    text-decoration: none;
  }
}
.custom-tips-pop {
  width: 272px;
}
</style>
